import { collection, doc, getCountFromServer, getDoc, query, where } from "firebase/firestore";
import { db } from "../../scripts/firebase";
export   const getActivePropertiesCount= async (uid)=>{
    const docRef = doc(db, "Listers", uid);
    const docSnap = await  getDoc(docRef);
    const listerData = docSnap.data();
    const coll = collection(
      db,
      "Listers",
      uid,
      "ListerProperties"
    );
    const query_ = query(
      coll,
      where("status", "==", "ACTIVE")
    );
    const snapshot =  await getCountFromServer(
      query_
    );
    let activeProps = snapshot.data().count;
    // console.log(activeProps)
    return activeProps
  }